import { render, staticRenderFns } from "./dish-task-info.vue?vue&type=template&id=197255e2&"
import script from "./dish-task-info.vue?vue&type=script&lang=js&"
export * from "./dish-task-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports